"use client";

import { useParams, usePathname } from "next/navigation";
import { useEffect, useState } from "react";

import {
  getSessionStorageItem,
  removeSession,
  setSessionStorageItem,
} from "@/utils/common/sessionStorageItemHelper/sessionStorageItemUtils";
import { checkExistValueAll } from "@/utils/common/validateHelper/validateUtils";
import { FeaturesTypePathEnum } from "@/utils/enums/FeaturePathGlobalEnum";
import { SessionStorageItemEnum } from "@/utils/enums/SessionStorageItemEnum";

import ErrorCustom from "./[lang]/error-custom";

const ErrorPage = () => {
  const refreshPromotion = SessionStorageItemEnum.hasRefreshedPromotion;
  const { slug } = useParams() as { slug: string };
  const pathname = usePathname();
  const [isShowError, setIsShowError] = useState(false);

  useEffect(() => {
    const hasRefreshed = getSessionStorageItem(refreshPromotion);

    if (
      pathname?.includes(`/${FeaturesTypePathEnum.PROMOTIONS}/`) &&
      checkExistValueAll(slug)
    ) {
      if (!hasRefreshed) {
        setSessionStorageItem(refreshPromotion, "true");
        window.location.reload();
      } else {
        removeSession(refreshPromotion); // Reset for future errors
        setIsShowError(true);
      }
    } else {
      setIsShowError(true);
    }
  }, []);

  if (isShowError) {
    return <ErrorCustom />;
  }

  return <div className="h-screen w-screen" />;
};

export default ErrorPage;
